var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row no-margin" },
    [
      _c(
        "div",
        { staticClass: "col p-0" },
        [
          _c(
            "vs-tooltip",
            {
              attrs: {
                text: _vm.$t("apps.pos.message.printorders"),
                position: "top"
              }
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-custom col no-margin action-btn",
                  class: [_vm.disabledClass],
                  on: {
                    click: function($event) {
                      return _vm.onclickPrint()
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-print" })]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col p-0" },
        [
          _c(
            "vs-tooltip",
            {
              attrs: {
                text: _vm.$t("apps.pos.message.clearorders"),
                position: "top"
              }
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-custom col no-margin action-btn",
                  class: [_vm.disabledClass],
                  on: {
                    click: function($event) {
                      return _vm.onClickClearOrders()
                    }
                  }
                },
                [
                  _c("i", {
                    staticClass: "far fa-trash-alt",
                    staticStyle: { "font-weight": "bold" }
                  })
                ]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("print-orders", {
        staticClass: "receipt-template",
        staticStyle: {
          position: "fixed",
          "z-index": "-1",
          top: "1mm",
          left: "1mm",
          "font-family": "tahoma",
          color: "black",
          width: "100%"
        },
        attrs: {
          orders: _vm.orders,
          total_price: _vm.totalPrice,
          created_at: _vm.moment().format("D/M/Y H:mm"),
          font_size: _vm.getShopInfo.settings.apps.pos.receipt.font_size
        }
      }),
      _vm._v(" "),
      _c("baseConfirmDeleteModal", {
        attrs: { show: _vm.modal.show, loading: _vm.modal.loading },
        on: {
          onClose: _vm.handleCloseModal,
          onCancel: _vm.handleCancleModal,
          onSubmit: _vm.handleSumitModal
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a9037c1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9037c1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/main/common/OptionsButton.vue
// module id = null
// module chunks = 